import styled from "styled-components";
import colors from "../../../config/colors";
import fonts from "../../../config/fonts";

export const ButtonContainer = styled.div`
  background-color: ${(props) =>
    props.variant === "primary" ? colors.primary : colors.background};
  color: ${(props) =>
    props.variant === "primary" ? colors.background : colors.primary};
  border: solid 2px
    ${(props) =>
      props.variant === "primary" ? colors.background : colors.primary};
  font-weight: bold;
  ${fonts.headings}
  padding:12px 30px;
  border-radius: 5px;
  transition: all 0.2s;
  font-size:16px;
  width:${props=>props.width};
  box-sizing:border-box;
  :hover {
    cursor: pointer;
    background-image:linear-gradient(to bottom right,${colors.background}00,${colors.secondary}55)
  }
  :active {
    background-image:linear-gradient(to bottom right,${colors.background}00,${colors.secondary}88)
  }
`;
